module.exports = __webpack_public_path__ + "img/39_29.681d3c9e.png";